import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsFounderApi,
  IAboutUsFounderApiRequest,
  IAboutUsFounderApiGetAttrs,
  IAboutUsFounderApiGetResponse,
  IAboutUsFounderApiSaveAttrs,
  IAboutUsFounderApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/founder/about-us-founder-api.interface'

// Constant
import { ApiConstant } from 'constant'
import { ABOUT_US_FOUNDER } from 'constant/content-management/about-us/about-us-founder.constant'

// Utils
import { commonUtils_delay } from 'utils/common/common.utils'

export class AboutUsFounderApi extends BaseApi<IAboutUsFounderApi> implements IAboutUsFounderApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_FOUNDER_URL

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsFounderApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsFounderApiGetResponse>} Promise<IAboutUsFounderApiGetResponse>
   */
  async aboutUsFounder_getAboutUsFounder(payload: IAboutUsFounderApiGetAttrs): Promise<IAboutUsFounderApiGetResponse> {
    try {
      // const response = await this.POST('/', payload.body, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_FOUNDER)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsFounderApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsFounderApiSaveResponse>} Promise<IAboutUsFounderApiSaveResponse>
   */
  async aboutUsFounder_saveAboutUsFounder(payload: IAboutUsFounderApiSaveAttrs): Promise<IAboutUsFounderApiSaveResponse> {
    try {
      // const requestPayload: IBaseApiRequestPayload = {
      //   method: payload.params?.id ? 'PUT' : 'POST',
      //   url: payload.params?.id ? `${this.url}/${payload.params.id}` : this.url,
      // }
      // const response = await this[requestPayload.method](requestPayload.url, {}, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_FOUNDER)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
